import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const jobsPerPage = 6;

const FicheMetier = () => {
  const [jobs, setJobs] = useState([]);
  const [categories, setCategories] = useState([]); // Pour stocker les catégories uniques
  const [selectedCategory, setSelectedCategory] = useState('Toutes');
  const [currentPage, setCurrentPage] = useState(1);
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(`${Url}/api/FicheMetierRouter/all`);
        const jobData = response.data.data;
        setJobs(jobData); // Stocker toutes les fiches métiers

        // Extraire les catégories uniques
        const uniqueCategories = [
          'Toutes',
          ...new Set(jobData.map((job) => job.metierCategory)),
        ];
        setCategories(uniqueCategories); // Mettre à jour la liste des catégories
      } catch (error) {
        console.error(
          'Erreur lors de la récupération des fiches métiers:',
          error,
        );
      }
    };

    fetchJobs();
  }, []);

  const filteredJobs =
    selectedCategory === 'Toutes'
      ? jobs
      : jobs.filter((job) => job.metierCategory === selectedCategory);

  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);

  const currentJobs = filteredJobs.slice(
    (currentPage - 1) * jobsPerPage,
    currentPage * jobsPerPage,
  );

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo(0, 0); // Déplace la page vers le haut
    }
  };
  return (
    <div className="fiche-layout">
      <aside className="fiche-sidebar">
        <h3>Catégories</h3>
        <ul>
          {categories.map((cat, index) => (
            <li
              key={index}
              className={cat === selectedCategory ? 'active' : ''}
              onClick={() => {
                setSelectedCategory(cat);
                setCurrentPage(1);
              }}
            >
              {cat}
            </li>
          ))}
        </ul>
      </aside>

      <main className="fiche-main">
        <h2 className="fiche-title">Tous les métiers</h2>
        <div className="fiche-grid">
          {currentJobs.map((job) => (
            <div key={job.metierId} className="fiche-card">
              <img
                src={`${Url}/images/${job.metierImage}`} // Adapte le chemin selon ton backend
                alt={job.metierTitle}
                className="fiche-image"
              />
              <div className="fiche-content">
                <span className="fiche-category">{job.metierCategory}</span>
                <h3 className="fiche-job-title">{job.metierTitle}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      job.metierDescription.length > 80
                        ? job.metierDescription.substring(0, 80) + '...'
                        : job.metierDescription,
                  }}
                ></p>
                <Link
                  className="fiche-button"
                  to={`/FicheMetierDetails/${job.metierId}`}
                >
                  <h6>En savoir plus</h6>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="pagination">
          <button
            onClick={() => changePage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={index + 1 === currentPage ? 'active' : ''}
              onClick={() => changePage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={() => changePage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      </main>
    </div>
  );
};

export default FicheMetier;
